import { Button, Checkbox, Form } from 'antd';
import { MASKS_TYPE, roundButtonWidth } from '../../../constants/constants';
import { formLabelMarginConfigWidth } from '../../../constants/gridConfig';
import { useStore } from '../../../store/store';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

const selector = ({ configuration, setConfiguration, masks, setEditableMask, landscape, currentTemplate }) => ({
  configuration,
  setConfiguration,
  // En-tête et pied se verrouillent ensemble (cf. le masque fusionné de
  // l'onglet Masques) : l'état de l'en-tête fait foi, absent = modifiable.
  headerFooterEditable: masks.find((m) => m.id === MASKS_TYPE.HEADER.id)?.editableMask !== false,
  setEditableMask,
  // Mêmes cas que l'onglet Masques, qui n'y propose pas l'en-tête/pied.
  hasHeaderFooter: !landscape && currentTemplate?.pattern !== 'section',
});

// Ce que les utilisateurs du document ont le droit de modifier. Sorti de
// l'onglet Marges, avec lequel ces réglages n'avaient aucun rapport.
export const TabsPermissions = () => {
  const {
    configuration,
    setConfiguration,
    headerFooterEditable,
    setEditableMask,
    hasHeaderFooter,
  } = useStore(selector);

  const handleChangeHeaderFooterEditable = () => {
    [MASKS_TYPE.HEADER.id, MASKS_TYPE.FOOTER.id].forEach((id) => setEditableMask(id, !headerFooterEditable));
  }

  const handleChangeEditableTemplate = () => {
    if (configuration?.editableTemplate || !configuration.hasOwnProperty('editableTemplate')) {
      setConfiguration({
        editableTemplate: false
      })
    } else {
      setConfiguration({
        editableTemplate: true
      })
    }
  }

  const handleChangeUnlockProposal = () => {
    if (configuration?.unlockProposal || !configuration.hasOwnProperty('unlockProposal')) {
      setConfiguration({
        unlockProposal: false
      })
    } else {
      setConfiguration({
        unlockProposal: true
      })
    }
  }

  const padLockState = () => {
    if (configuration?.editableTemplate || !configuration.hasOwnProperty('editableTemplate')) {
      return (<FontAwesomeIcon
        icon={icon({ name: 'lock-keyhole-open', style: 'light' })}
        style={{ margin: 0, fontSize: 15 }} />)
    }
    else {
      return (<FontAwesomeIcon
        icon={icon({ name: 'lock-keyhole', style: 'light' })}
        style={{ margin: 0, fontSize: 15 }} />)
    }
  }

  return (
    <>
      <Form.Item
        label={'Containers éditables pour les utilisateurs ? (les nouveaux containers possèderont cette valeur)'}
        labelCol={{
          flex: `${formLabelMarginConfigWidth + 59}px`,
        }}
      >
        <Button shape="circle"
          size={14}
          onClick={handleChangeEditableTemplate}
          style={{
            width: roundButtonWidth,
            height: roundButtonWidth,
            minWidth: roundButtonWidth,
            minHeight: roundButtonWidth,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          icon={
            padLockState()
          }
        />
      </Form.Item>
      <Form.Item
        label={'Ajout et suppression de blocs autorisés ?'}
        labelCol={{
          flex: `${formLabelMarginConfigWidth + 59}px`,
        }}
      >
        <Checkbox checked={configuration.unlockProposal} onClick={handleChangeUnlockProposal} />
      </Form.Item>
      {hasHeaderFooter && (
        <Form.Item
          label={'En-tête et pied de page modifiables par les utilisateurs ?'}
          labelCol={{
            flex: `${formLabelMarginConfigWidth + 59}px`,
          }}
        >
          <Checkbox checked={headerFooterEditable} onClick={handleChangeHeaderFooterEditable} />
        </Form.Item>
      )}
    </>
  );
};
